module.exports = __webpack_public_path__ + "static/media/write.11f34a48.svg";